<template>
  <div class="otp-by-date-view">
    <div v-if="loading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div v-else>
      <!-- Chart Container -->
      <div class="chart-container position-relative pt-5">
        <!-- Combined OTP Chart with Dual Y-Axes -->
        <combined-otp-chart
          ref="combinedChart"
          :late-arrivals="lateArrivals"
          :early-departures="earlyDepartures"
          :otp-percentages="otpPercentages"
          :left-behind-data="leftBehindData"
          :date-stats="dateStats"
          :threshold="threshold"
          :date-range="filters.dateRange"
          @point-click="handlePointClick"
        />

        <!-- Left Behind Indicators (Purple dots) -->
        <left-behind-indicators :data="leftBehindData" :chart-data="lateArrivals" @dot-hover="handleLeftBehindHover" />

        <!-- Export Menu -->
        <export-menu class="download-btn" @export="exportChart" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CombinedOtpChart from '../charts/CombinedOtpChart.vue';
import LeftBehindIndicators from '../charts/LeftBehindIndicators.vue';
import ExportMenu from '../components/ExportMenu.vue';

export default {
  name: 'OtpByDate',
  components: {
    CombinedOtpChart,
    LeftBehindIndicators,
    ExportMenu,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    threshold: {
      type: Number,
      default: 5,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('otpDashboard', {
      lateArrivals: 'lateArrivalsChartData',
      earlyDepartures: 'earlyDeparturesChartData',
      otpPercentages: 'otpPercentagesChartData',
      leftBehindData: 'leftBehindChartData',
      dateStats: 'dateStats',
    }),
  },
  methods: {
    handlePointClick(data) {
      // Navigate to Trips screen with filters preserved
      this.$emit('drill-down', {
        date: data.date,
        type: data.type,
        routes: this.filters.routes,
        direction: this.filters.direction,
      });
    },
    handleLeftBehindHover(data, position) {
      // Handle left behind hover if needed
      console.log('Left behind hover:', data, position);
    },
    exportChart(format) {
      if (!this.$refs.combinedChart) {
        console.error('Combined chart component not found');
        return;
      }

      switch (format) {
        case 'png':
          this.$refs.combinedChart.exportAsPNG();
          break;
        case 'csv':
          this.$refs.combinedChart.exportAsCSV();
          break;
        case 'excel':
          this.$refs.combinedChart.exportAsExcel();
          break;
        default:
          console.error('Unknown export format:', format);
      }
    },
  },
};
</script>

<style scoped>
.otp-by-date-view {
  padding: 20px;
}

.chart-container {
  min-height: 500px;
}

.download-btn {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
